import axios from "../plugins/axios.plugin";

class PaymentInstrumentService {
  baseServicePath = "/api/payment-instrument";

  getAllPaymentProviders() {
    return axios.get(`${this.baseServicePath}/show/provider`);
  }
  getMyPaymentInstruments() {
    return axios.get(`${this.baseServicePath}/me`);
  }
  storePaymentInstrument(payLoad) {
    return axios.post(`${this.baseServicePath}/store`, payLoad);
  }

  deletePaymentInstrument(payLoad) {
    return axios.post(`${this.baseServicePath}/delete`, payLoad);
  }

  showAPayment(id) {
    return axios.get(`${this.baseServicePath}/show?id=${id}&properties=1`);
  }
  filterPayment(payLoad, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}`,
      payLoad
    );
  }
  getAllPaymentsNoPagination(payload) {
    return axios.post(`${this.baseServicePath}/filter/index`, payload);
  }
  searchPayments(params) {
    return axios.post(`${this.baseServicePath}/search/index`, params);
  }
}
export const paymentInstrumentService = new PaymentInstrumentService();
